import React, { useContext, useState } from 'react';
import { MessageSquare, Star, MapPin, Phone, Mail, Building, Edit } from 'lucide-react';
import DirectoryContext from '../../../context/directoryManagementContext';
import AddContactModal from './AddContactModel';
import useAxiosInstance from '../../../lib/useAxiosInstance';
import MapModal from '../../directoryManagement/MapModel';
import { useStartOrOpenChat } from '../../../utils/chatHelpers';

export const ContactListItem = ({ contact, onToggleFavourite, setActiveTab }) => {
  
  const axiosInstance = useAxiosInstance();
  const { startOrOpenChat } = useStartOrOpenChat();
  const directoryContext = useContext(DirectoryContext);
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [mapLocation, setMapLocation] = useState({ lat: 0, lng: 0 });
  const [mapPlace, setMapPlace] = useState("");
  
  const getTypeColor = (type) => {
    switch (type) {
      case 'users':
        return 'bg-blue-100 !text-blue-700';
      case 'party':
        return 'bg-green-100 !text-green-700';
      case 'personal':
        return 'bg-purple-100 !text-purple-700';
      default:
        return 'bg-gray-100 !text-gray-700';
    }
  };

  const handleEdit = async (record,type) => {
    let response;
    if(type==="party")
      response = await axiosInstance.get(`api/directory/party-members/${record._id}`);
    else if(type==='personal')
      response = await axiosInstance.get(`api/directory/other-contacts/${record._id}`);
    directoryContext.updateEditData(response?.data?.data);
    directoryContext.updateEditType(type);
    directoryContext.updateAddMode(false);
    directoryContext.updateOpenModal(true);
  };

  const getTypeLabel = (type) => {
    switch (type) {
      case 'users':
        return 'Portal User';
      case 'party':
        return 'Party Member';
      case 'personal':
        return 'Personal Contact';
      default:
        return type;
    }
  };
  return (
    <div className="card-wrapper hover:shadow-md transition-shadow duration-200">
      <div className="flex items-center justify-between">
        {/* Left Section - Avatar and Info */}
        <div className="flex items-center space-x-4 flex-1 min-w-0">
          <div className="w-12 h-12 bg-gradient-to-br from-[#004877] to-purple-200 rounded-full flex items-center justify-center text-white font-medium flex-shrink-0">
            {contact?.firstName.split(' ').map((n) => n[0]).join('').toUpperCase()}
          </div>

          <div className="flex-1 min-w-0">
            <div className="flex items-center space-x-2 mb-1">
              <h3 className="font-medium text-gray-900 truncate">{contact.firstName} {contact.lastName}</h3>
              <span
                className={`inline-block px-2 py-1 text-xs rounded-full font-medium ${getTypeColor(
                  contact?.type
                )} flex-shrink-0`}
              >
                {getTypeLabel(contact?.type)}
              </span>
            </div>

            <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600">
              <div className="flex items-center space-x-1">
                <Phone className="w-4 h-4" />
                <span>{contact?.phone}</span>
              </div>

              {contact.email && (
                <div className="flex items-center space-x-1">
                  <Mail className="w-4 h-4" />
                  <span className="truncate">{contact?.email}</span>
                </div>
              )}

              {(contact?.position || contact?.role) && (
                <div className="flex items-center space-x-1">
                  <Building className="w-4 h-4" />
                  <span>{contact?.position || contact?.role}</span>
                  {contact?.officeId && <span className="text-gray-400">• {contact?.officeId?.officeName}</span>}
                </div>
              )}

              {contact?.place && (
                <div className="flex items-center space-x-1">
                  <MapPin className="w-4 h-4" />
                  <span>{contact?.place}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Right Section - Actions */}
        <div className="flex items-center space-x-2 flex-shrink-0 ml-4">
          {contact?.type === 'users' ? (
            <button 
              className="bg-[#004877] text-white px-3 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2 text-sm font-medium"
              onClick={() => 
              {
                startOrOpenChat(contact._id);
                setActiveTab("messages")
              }}
            >
              <MessageSquare className="w-4 h-4" />
              <span>Chat</span>
            </button>
          ) : (
            <button className="bg-gray-100 text-gray-500 px-3 py-2 rounded-lg cursor-not-allowed flex items-center space-x-2 text-sm font-medium">
              <MessageSquare className="w-4 h-4" />
              <span>No Chat</span>
            </button>
          )}

          {/* {contact?.location && (
            <button className="p-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
              <MapPin className="w-4 h-4 text-gray-500" />
            </button>
          )} */}
           {(contact?.type === "party" || contact?.type === "personal") && (
                <button
                  className="p-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                 onClick={async () => {
                      setMapLocation(contact?.coordinates);
                      setMapPlace(contact?.place);
                      setMapModalOpen(true);
                    }}
                >
                  <MapPin className="w-4 h-4 text-gray-500" />
                </button>
              )}

          <button
            // onClick={() => onToggleFavourite(contact.id)}
            onClick={() => onToggleFavourite(contact._id, contact?.type)}
            className={`p-2 rounded-lg transition-colors ${
              contact.isFavourite
                ? 'text-yellow-500 hover:text-yellow-600 bg-yellow-50'
                : 'text-gray-400 hover:text-gray-500 hover:bg-gray-50'
            }`}
          >
            <Star className={`w-4 h-4 ${contact?.isFavourite ? 'fill-current' : ''}`} />
          </button>

          {(contact.type === "party" || contact.type === "personal") && <button className="p-2 rounded-lg text-gray-400 hover:text-gray-500 hover:bg-gray-50 transition-colors"
            //  <Edit className="w-4 h-4" />
          // </button>
            onClick={() => handleEdit(contact,contact?.type)}
          >
            <Edit className="w-4 h-4" />
          </button>}
        </div>
      </div>
      {mapModalOpen && (
        <MapModal
          visible={mapModalOpen}
          onClose={() => setMapModalOpen(false)}
          location={mapLocation}
          place={mapPlace}
        />
      )}
    </div>
  );
};
